import { render, staticRenderFns } from "./QnIndustry.vue?vue&type=template&id=886fe524&scoped=true&"
import script from "./QnIndustry.vue?vue&type=script&lang=js&"
export * from "./QnIndustry.vue?vue&type=script&lang=js&"
import style0 from "./QnIndustry.vue?vue&type=style&index=0&id=886fe524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886fe524",
  null
  
)

export default component.exports